import React, { useState } from "react";
import { auth, googleProvider } from "./firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";

const LoginScreen = ({ onLogin, onGoToRegister, onGoToOnboarding }) => {
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLogin(true); 
    } catch (err) {
      if (err.code === "auth/invalid-credential") {
        setError("帳號或密碼錯誤");
      } else {
        setError("登入失敗，請確認帳號密碼或網路連線");
      }
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      onLogin(true); 
    } catch (err) {
      setError("Google 登入失敗");
    }
  };

  return (
    <div
      style={{
        width: "100vw", 
        height: "100vh",
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center",
        background: "var(--bg-main)",
        overflow: "hidden" // 💡 確保任何情況下都不會出現側邊滑動條
      }}
    >
      <div
        style={{
          width: 360,
          padding: "30px", // 💡 縮小上下內邊距 (原本為 40px 30px)
          background: "var(--bg-panel)",
          borderRadius: 12,
          border: "1px solid var(--border-color)",
          boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: 15, color: "#fff", fontWeight: "600" }}>系統登入</h2>
        
        {/* 💡 將表單間距從 15 縮小為 12 */}
        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: 4, fontSize: 13, color: "#aaa" }}>Email 帳號</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              placeholder="請輸入 Email" 
              required
              style={{ width: "100%" }} 
            />
          </div>

          <div style={{ textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: 4, fontSize: 13, color: "#aaa" }}>密碼</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              placeholder="請輸入密碼" 
              required
              style={{ width: "100%" }} 
            />
          </div>

          {error && <div style={{ color: "#ef4444", fontSize: 13 }}>{error}</div>}

          <button
            type="submit"
            style={{
              marginTop: 5, // 💡 稍微縮減按鈕上方的距離
              padding: "10px", 
              background: "var(--accent-color)", color: "#fff",
              border: "none", borderRadius: 6,
              fontSize: 15, fontWeight: "600", cursor: "pointer",
            }}
          >
            登入
          </button>
        </form>

        {/* 💡 縮小分隔線的上下間距 (從 20px 縮小為 15px) */}
        <div style={{ margin: "15px 0", display: "flex", alignItems: "center", color: "#666", fontSize: 12 }}>
          <div style={{ flex: 1, height: "1px", background: "#333" }}></div>
          <span style={{ margin: "0 10px" }}>或</span>
          <div style={{ flex: 1, height: "1px", background: "#333" }}></div>
        </div>

        <button
          onClick={handleGoogleLogin}
          style={{
            width: "100%", padding: "10px",
            background: "#fff", color: "#444",
            border: "none", borderRadius: 6,
            fontSize: 14, fontWeight: "600", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 8
          }}
        >
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width="18" alt="G" />
          使用 Google 帳號登入
        </button>

        {/* 💡 縮小底部按鈕與上方的距離 (從 25px 縮小為 20px) */}
        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
          <button
            type="button"
            onClick={onGoToOnboarding}
            style={{
              flex: 1, padding: "10px",
              background: "transparent", color: "#aaa",
              border: "1px solid #444", borderRadius: 6,
              fontSize: 13, cursor: "pointer", transition: "all 0.2s"
            }}
          >
            📖 功能導覽
          </button>

          <button
            type="button"
            onClick={onGoToRegister}
            style={{
              flex: 1, padding: "10px",
              background: "transparent", color: "#3b82f6",
              border: "1px solid #1d4ed8", borderRadius: 6,
              fontSize: 13, cursor: "pointer", transition: "all 0.2s"
            }}
          >
            免費註冊 →
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;